import './ReturnAndExchange.scss';

const ReturnAndExchange = () => {
   return (
      <div className='return-and-exchange'>
         <div className='return-and-exchange__container'>
            <h2>ПОВЕРНЕННЧЯ ТА ОБМІН</h2>
            <p className='return-and-exchange__text'>
               Ви можете повернути/обміняти куплений товар в нашому магазині за
               умови, якщо: товар не використовувався та збережений товарний
               вигляд виробу (відсутність слідів експлуатації та носіння,
               наявність оригінальної і неушкодженою упаковки і ярликів); з
               моменту покупки не пройшло більше 14 календарних днів.
            </p>
            <p className='return-and-exchange__text'>
               Повернення необхідно оформити як звичайну посилку (без накладного
               платежу). Всі витрати при цьому несе покупець. Важливо! Не
               обклеюйте фірмову коробку кросівок клейкою стрічкою - такі
               повернення не будуть розглянуті.
            </p>
            <p className='return-and-exchange__text'>
               Повернення коштів за товар здійснюється за реквізитами. Строк
               перерахування коштів – до 7 робочих днів після отримання та
               перевірки поверненого товару.
            </p>
            <p className='return-and-exchange__text'>
               Відповідно до Закону України "Про захист прав споживача"
               поверненню не підлягає товар належної якості, у тому числі:
            </p>

            <ul className='return-and-exchange__list'>
               <li>
                  Швейні та трикотажні вироби (вироби швейні та трикотажні
                  білизняні, вироби панчішно-шкарпеткові);
               </li>
               <li>
                  Вироби та матеріали, що контактують із харчовими продуктами, з
                  полімерних матеріалів, у тому числі для разового використання;
               </li>
               <li>Парфумерно-косметичні товари;</li>
               <li>
                  Технічно складні товари побутового призначення, на які
                  встановлені гарантійні терміни (в т.ч. годинники).
               </li>
            </ul>
         </div>
      </div>
   );
};

export default ReturnAndExchange;
